export const permissions = {
  diagnostician: 'Diagnostician',
  diagnosticiansManagement: 'DiagnosticiansManagement',
  diagnosticModule: 'DiagnosticModule',
  resultsModule: 'ResultsModule',
  reportGenerate: 'ReportGenerate',
  reportList: 'ReportList',
  reportAccess: 'ReportAccess',
  roleEditor: 'RoleEditor',
  userAccess: 'UserAccess',
  userEditor: 'UserEditor',
  formModule: 'FormModule',
  surveys: 'Surveys',
  unitManagement: 'UnitManagement',
}

export const roles = {
  platformAdmin: 'Administrator platformy',
  unitAdmin: 'Administrator jednostki',
  unitDirector: 'Dyrektor jednostki',
  diagnostician: 'Diagnosta',
}

export const subAreas = {
  cognitiveFlexibility: 'Elastyczność poznawcza',
  attentionControl: 'Uwaga',
  workMemory: 'Pamięć',
  reasoning: 'Rozumowanie',
  perceptionSpeed: 'Szybkość percepcyjna',
  readingUnderstanding: 'Czytanie-rozumienie',
  readingDecoding: 'Czytanie-dekodowanie',
  charactersRecognition: 'Znajomość liter',
  pragmatics: '	Pragmatyka',
  semantics: 'Semantyka',
  grammar: 'Gramatyka',
  phonology: 'Fonologia',
  writing: 'Pisanie',
  perceptionAccuracy: 'Poprawność percepcyjna',
  planning: 'Planowanie',
  advancedExecutiveFunctions: 'Złożone funkcje wykonawcze',
  perception: '	Percepcja',
  speech: 'Mowa',
  reading: 'Czytanie',
  basicExecutiveFunctions: 'Podstawowe funkcje wykonawcze',
}
export const inquiryForm = [
  {
    name: 'KAPP_SNIG(N)',
    minAgeInMonths: 71,
    maxAgeInMonths: 299,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIG(R)',
    minAgeInMonths: 71,
    maxAgeInMonths: 299,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIU(N)',
    minAgeInMonths: 71,
    maxAgeInMonths: 299,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIU(R)',
    minAgeInMonths: 71,
    maxAgeInMonths: 299,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIZ_M(N)',
    minAgeInMonths: 71,
    maxAgeInMonths: 143,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIZ_M(R)',
    minAgeInMonths: 71,
    maxAgeInMonths: 143,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIZ_S(N)',
    minAgeInMonths: 143,
    maxAgeInMonths: 299,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_SNIZ_S(R)',
    minAgeInMonths: 143,
    maxAgeInMonths: 299,
    speLevel: [1] as SpeLevel[],
  },
  {
    name: 'KAPP_S_S(N)',
    minAgeInMonths: 83,
    maxAgeInMonths: 119,
    speLevel: [0, 2, 3, 4, 6, 8, 9, 10, 11, 12] as SpeLevel[],
  },
  {
    name: 'KAPP_S_S(R)',
    minAgeInMonths: 83,
    maxAgeInMonths: 119,
    speLevel: [0, 2, 3, 4, 6, 8, 9, 10, 11, 12] as SpeLevel[],
  },
  {
    name: 'KAPP_S_P(N)',
    minAgeInMonths: 35,
    maxAgeInMonths: 83,
    speLevel: [0, 2, 3, 4, 6, 8, 9, 10, 11, 12] as SpeLevel[],
  },
  {
    name: 'KAPP_S_P(R)',
    minAgeInMonths: 35,
    maxAgeInMonths: 83,
    speLevel: [0, 2, 3, 4, 6, 8, 9, 10, 11, 12] as SpeLevel[],
  },
  {
    name: 'KAPP_S_D3-5(R)',
    minAgeInMonths: 2,
    maxAgeInMonths: 5,
    speLevel: [0] as SpeLevel[],
  },
  {
    name: 'KAPP_S_D6-11(R)',
    minAgeInMonths: 5,
    maxAgeInMonths: 11,
    speLevel: [0] as SpeLevel[],
  },
  {
    name: 'KAPP_S_D12-17(R)',
    minAgeInMonths: 11,
    maxAgeInMonths: 17,
    speLevel: [0] as SpeLevel[],
  },
  {
    name: 'KAPP_S_D18-23(R)',
    minAgeInMonths: 17,
    maxAgeInMonths: 23,
    speLevel: [0] as SpeLevel[],
  },
  {
    name: 'KAPP_S_D24-29(R)',
    minAgeInMonths: 23,
    maxAgeInMonths: 29,
    speLevel: [0] as SpeLevel[],
  },
  {
    name: 'KAPP_S_D30-35(R)',
    minAgeInMonths: 29,
    maxAgeInMonths: 35,
    speLevel: [0] as SpeLevel[],
  },
] as const

export const mainContentTagId: string = "main-content";

export type InquiryFormType = typeof inquiryForm[number]
export type SpeLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
